import { Component, Input, ViewChild, OnInit, Output, EventEmitter } from '@angular/core';
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { MatDialog } from '@angular/material/dialog';
import { SnackService } from '../../services';
import { NgForm } from '@angular/forms';
import { HospitalXService } from '../../api';
import { DeleteDialogComponent } from '../../common-ui/delete-dialog';

@Component({
  selector: 'school-cart-camera-lists',
  templateUrl: './cart-camera-lists.component.html',
  styleUrls: ['./cart-camera-lists.component.scss']
})
export class CartCameraListsComponent implements OnInit {

  @Input() EditIconPath: string;
  @Input() DeleteIconPath: string;
  @Input() PageSize_Options: any;
  @Input() Page_Size: any;

  @ViewChild(MatPaginator)
  paginator: MatPaginator;
  @ViewChild(MatSort)
  sort: MatSort;
  isCreateCamera = false;

  maxdate: any = new Date();
  filterdata: string;
  from_date: any;
  fromdate: any;
  todate: any;
  orderby: string;
  direction: string;

  editicon: string;
  deleteicon: string;

  cameraId: number;
  Page_Index: number;
  totalLength: number;
  last_page: number;
  FormStatus: boolean = false;
  AccFormtype = "accordion";

  paginatorIndex: any;


  camera_displayedColumns: string[] = [
    "id",
    "ip_address",
    "camera",
    "type",
    "actions",
  ];



  @Input() formtype: string;
  @Output() accordionEvent = new EventEmitter();
  @Input() isExpand: any;

  cameradataSource = new MatTableDataSource;

  constructor(
    private dialog: MatDialog,
    private _userService: HospitalXService,
    private _snackService: SnackService,
  ) { }

  ngOnInit(): void {
    this.cameradataSource.paginator = this.paginator;
    this.cameradataSource.sort = this.sort;

    this.editicon = this.EditIconPath;
    this.deleteicon = this.DeleteIconPath;

    this.paginatorIndex = {
      pageIndex: 0,
      pageSize: this.Page_Size,
      active: "id",
      direction: "desc"
    };
  }


  ngOnDestroy(): void {
    this.accordionEvent.unsubscribe();
  }

  ngOnChanges(): void {
    if (this.isExpand == true) {
      this.LoadData(this.paginatorIndex);
    }
  }



  showcreateCamera(actionType, camera_id) {

    this.isCreateCamera = true;

    if (actionType == "update") {
      this.FormStatus = true;
      this.cameraId = camera_id;
    }
    else {
      this.FormStatus = false;
      this.cameraId = camera_id;
    }
  }

  showCameralist() {
    this.isCreateCamera = false;
    this.FormStatus = false;
    this.LoadData(this.paginatorIndex);
  }

  LoadData(event) {
    event.active = this.orderby ? this.orderby : "id";
    event.direction = this.direction ? this.direction : "desc";

    this.Page_Index = event.pageIndex + 1;

    this._userService.getCameraList(event).subscribe(
      result => {
        this.cameradataSource = new MatTableDataSource(result.body.data.cameras);
        this.totalLength = result.body.data.pagination.total;
        this.Page_Size = result.body.data.pagination.per_page;
        this.last_page = result.body.data.pagination.last_page;
        var Pageoptions = new Array();
        for (let i = 1; i <= this.last_page; i++) {
          Pageoptions.push(result.body.data.pagination.per_page * i);
        }
        this.PageSize_Options = Pageoptions;


      }, error => {
        this._snackService.openSnackBar("danger", "Failed to Load updated data..");
      });
  }


  deleteCamera(id: string): void {

    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      width: '450px',
      data: {
        message: 'Are you sure want to delete?',
        deleteId: id,
        buttonText: {
          ok: 'Yes',
          cancel: 'No'
        }
      }
    });


    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        this._userService.deleteCameras(res['deleteId']).subscribe(
          result => {

            this._snackService.openSnackBar("success", "Camera Deleted Successfully!...");
            this.LoadData(this.paginatorIndex);


          }, error => {
            this._snackService.openSnackBar("danger", "Faile to Delete Camera!...");
          });

      }
    });


  }

}
